import React from 'react';
import { operatingSystem, OS } from '../screenUtils';
import { lazyWithReload } from '../lazy/lazyWithReload';

const ScrollerStyle = lazyWithReload(() => import('./ScrollerStyle'));

const ConditionalLoading: React.FC = ({ children }) => (
  <>
    <React.Suspense fallback={null}>{operatingSystem !== OS.MAC && <ScrollerStyle />}</React.Suspense>
    {children}
  </>
);

export default ConditionalLoading;
